import {Session} from "../../services/Session";
import {User, IRepLocInfo, IUserAlias} from "../../services/User";
import {IUser} from "../../interfaces/IUser";
import {Component, Output, EventEmitter} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {IDistributor} from "../../interfaces/IDistributor";
import {ISpecialty} from "../../interfaces/ISpecialty";
import {Distributors} from "../../services/Distributors";
import {Specialties} from "../../services/Specialties";
import {Locations} from "../../services/Locations";
import {Config} from "../../services/Config";
import {ILocation} from "../../interfaces/ILocation";
import {UrlParser} from "../../services/UrlParser";
import {Notify} from "../../services/Notify";
import {IUserTotalSales} from "../../interfaces/IUserTotalSales";
import {JobTypes} from "../../services/JobTypes";
import {IJobType} from "../../interfaces/IJobType";

@Component({
  selector: 'user-cmp',
  templateUrl: './user.html',
})
export class UserCmp {
  @Output() update = new EventEmitter();
  @Output() refreshAliases = new EventEmitter();
  public user: IUser;
  public loading: boolean;
  public id;
  public distributorsList: IDistributor[] = [];
  public distributorsMap: { [id: number]: IDistributor; } = {};
  public specialtiesList: ISpecialty[] = [];
  public specialtiesMap: { [id: number]: ISpecialty; } = {};
  public tab = 1;
  public locsTab = 1;
  public locsCount:any = {};
  public locs: ILocation[] = [];
  public repLocsInfo: IRepLocInfo[] = [];
  public repConnectedCount = 0;
  public repReportingCount = 0;
  public managers: IUser[] = [];
  public newRep: IUser;
  public newLocation: ILocation;
  public saving = false;
  public changeLocationMode = false;
  public resetPasswordMode = false;
  public changingRepMgr = false;
  public userToken = '';
  public tokenLoading = false;
  public totalSales: IUserTotalSales;
  public enablingLogin = false;
  public requestAssignToLocation: ILocation;
  public assigningToLocation = false;
  public typeRep = 3;
  public tabOpened = {};
  public aliasesCount;
  public displayLeftColumn = true;
  public addCmMode = false;

  constructor(public session: Session, public users: User, public params: ActivatedRoute, public router: Router,
    public distributors: Distributors, public specialties: Specialties, public urlParser: UrlParser,
    public locations: Locations, public config: Config) {
    this.typeRep = config.userTypeRep;
  }

  ngOnInit() {
    this.params.params.subscribe(params => {
      this.init(params);
    });
  }

  init(params) {
    this._setTabValue(1);
    this.locsTab = 1;
    this.id = parseInt(params['id']);
    if (!this.id) {
      this.router.navigate(['']);
      return;
    }
    this.parseUrlParams();
    this.session.redirectIfNotAuth();
    this.loadUser();
    this.distributors.loadToList(this.distributorsList);
    this.distributors.loadToMap(this.distributorsMap);
    this.specialties.loadToList(this.specialtiesList);
    this.specialties.loadToMap(this.specialtiesMap);
    this.locations.getRepLocationsCount(this.id).then(c => this.locsCount = c, () => {});
    this.users.getTotalSalesReport(this.id).subscribe(r => this.totalSales = r, () => {});
  }

  loadUser() {
    this.loading = true;
    this.users.getUserInfo(this.id).then((user) => {
      this.user = user;
      this.loading = false;
      this.update.emit(this.user);
      this.onUserLoad();
    }, () => {
      this.loading = false;
    });
  }

  refreshUserInfo() {
    if (!this.id) {
      return;
    }
    this.users.getFreshUserInfo(this.id).subscribe((info) => {
      this.user = info;
      this.update.emit(this.user);
    }, () => {});
  }

  onUserLoad() {
    if (this.user && this.user.type_id == this.typeRep) {
      this.users.getRelatedLocations(this.id).subscribe((response) => {
        this.locs = response.locations;
        this.repLocsInfo = response.locations_info;
        this.repConnectedCount = response.connected_cnt;
        this.repReportingCount = response.reporting_cnt;
      }, () => {});
      this.users.getRepClientManagers(this.id).subscribe((managers) => {this.managers = managers;});
    }
    this.loadReqAssignLocation();
  }

  addRep() {
    this.newRep = <IUser>{};
    this.newRep.type_id = this.config.userTypeRep;
  }

  cancelNewRepSave() {
    this.newRep = null;
  }

  repCreated() {
    this.newRep = null;
  }

  setNewLocation(newLocation: ILocation) {
    if (!newLocation || !newLocation.id || !this.user || !this.user.id) {
      return;
    }
    this.saving = true;
    let n = new Notify();
    let loc_id_before = this.user.location_id;
    this.user.location_id = newLocation.id;
    this.users.updateUser(this.user).then(() => {
      this.users.addUserLocation(this.user.id, newLocation.id).then(null, () => {});
      this.saving = false;
      this.changeLocationMode = false;
      this.newLocation = null;
      this.update.emit(this.user);
      n.success('Location updated');
    }, (err) => {
      this.user.location_id = loc_id_before;
      this.saving = false;
      n.httpErr(err);
    });
  }

  setTab(i) {
    this._setTabValue(parseInt(i));
    this.urlParser.setParameter('tab', this.tab);
  }

  _setTabValue(i: number) {
    if (i < 1 || i > 99) {
      i = 1;
    }
    this.tab = i;
    this.tabOpened[i.toString()] = true;
  }

  parseUrlParams() {
    let urlParams = this.urlParser.getParameters();
    if (urlParams.tab) {
      this._setTabValue(parseInt(urlParams.tab));
    }
  }

  loadReqAssignLocation() {
    if (!this.user || !this.user.id) {
      return;
    }
    try {
      let urlParams = this.urlParser.getParameters();
      if (urlParams['req_assign_loc']) {
        let rlocID = parseInt(urlParams['req_assign_loc']);
        if (rlocID > 0 && this.user.location_id != rlocID) {
          this.locations.getLocation(rlocID).then(l => this.requestAssignToLocation = l, () => {});
        }
      }
    } catch (e) {

    }
  }

  addNewCmUser(newCm: IUser) {
    if (!this.user || !this.user.id || !newCm || !newCm.id || newCm.type_id != 2) {
      return;
    }
    
    // Check if this CM is already assigned
    const alreadyAssigned = this.user.__cm_users?.some(cm => cm.id === newCm.id);
    if (alreadyAssigned) {
      try {
        let n = new Notify();
        n.warning('This Client Manager is already assigned to this user');
      } catch (e) {
      }
      return;
    }
    
    this.changingRepMgr = true;
    const prevCmUsers = this.user.__cm_users || [];
    
    // Add the new CM to the existing list
    const newCmUser = {
      id: newCm.id,
      fname: newCm.fname,
      lname: newCm.lname,
      email: newCm.email
    };

    this.user.__cm_users = [...prevCmUsers, newCmUser];
    
    this.users.updateUser(this.user).then(() => {
      this.changingRepMgr = false;
      this.addCmMode = false;
      this.update.emit(this.user);
      this.loadUser();
      this.users.getRepClientManagers(this.id).subscribe((managers) => {this.managers = managers;});
      try {
        let n = new Notify();
        n.success('Client Manager added successfully');
      } catch (e) {
      }
    }, (err) => {
      this.changingRepMgr = false;
      this.user.__cm_users = prevCmUsers;
      try {
        let n = new Notify();
        n.httpErr(err);
        console.error(err);
      } catch (e) {
      }
    });
  }

  removeCmUser(cmId: number) {
    if (!this.user || !this.user.id || !cmId) {
      return;
    }
    
    if (this.user.__cm_users?.length <= 1) {
      try {
        let n = new Notify();
        n.warning('Rep users must have at least one Client Manager assigned');
      } catch (e) {
      }
      return;
    }
    
    this.changingRepMgr = true;
    const prevCmUsers = this.user.__cm_users || [];
    
    // Remove the specified CM
    this.user.__cm_users = prevCmUsers.filter(cm => cm.id !== cmId);
    
    this.users.updateUser(this.user).then(() => {
      this.changingRepMgr = false;
      this.addCmMode = false;
      this.update.emit(this.user);
      this.loadUser();
      this.users.getRepClientManagers(this.id).subscribe((managers) => {this.managers = managers;});
      try {
        let n = new Notify();
        n.success('Client Manager removed successfully');
      } catch (e) {
      }
    }, (err) => {
      this.changingRepMgr = false;
      this.user.__cm_users = prevCmUsers;
      try {
        let n = new Notify();
        n.httpErr(err);
        console.error(err);
      } catch (e) {
      }
    });
  }

  resetPassword() {
    if (!this.resetPasswordMode || !this.user || !this.user.id) {
      return;
    }
    this.saving = true;
    this.users.resetPassword(this.user.id).subscribe(() => {
      this.resetPasswordMode = false;
      this.saving = false;
      let n = new Notify();
      n.success('Password reset and sent to ' + this.user.email);
    }, (err) => {
      this.saving = false;
      console.error(err);
      let n = new Notify();
      n.httpErr(err);
    });
  }

  loadToken() {
    if (!this.userToken) {
      this.tokenLoading = true;
      this.users.getTokenForUserID(this.id).subscribe((token) => {
        this.userToken = token;
        this.tokenLoading = false;
      }, (err) => {
        this.tokenLoading = false;
        console.error(err);
      });
    }
  }

  enableLogin() {
    this.enablingLogin = true;
    this.users.enableLogin(this.user.id).subscribe(() => {
      this.user.is_disabled = false;
      this.enablingLogin = false;
    }, () => {
      this.enablingLogin = false;
    });
  }

  approveAssignReq() {
    if (!this.requestAssignToLocation || !this.requestAssignToLocation.id || !this.user || !this.user.id) {
      return;
    }
    this.assigningToLocation = true;
    let ex = this.user.location_id;
    this.user.location_id = this.requestAssignToLocation.id;
    let n = new Notify();
    this.users.updateUser(this.user).then(() => {
      this.assigningToLocation = false;
      n.success('Done');
      this.requestAssignToLocation = null;
    }, (err) => {
      this.assigningToLocation = false;
      this.user.location_id = ex;
      n.httpErr(err);
    });
  }

  declineAssignReq() {
    this.requestAssignToLocation = null;
  }
}
